export default "__VITE_ASSET__f0zpMLpE__"